'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Button } from './Button';
function showOverlay(node: HTMLDialogElement | null) {
  if (!node) return;
  node.showModal();
  return () => node.close();
}
export function Overlay(t0) {
  const $ = _c(8);
  const {
    children,
    label,
    onClose,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `lookbook lookbook-overlay ${className}`;
  let t3;
  if ($[0] !== onClose) {
    t3 = <Button className="lookbook-overlay-close" onClick={onClose} autoFocus={true}>Close</Button>;
    $[0] = onClose;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== label || $[4] !== onClose || $[5] !== t2 || $[6] !== t3) {
    t4 = <dialog className={t2} ref={showOverlay} aria-label={label} onCancel={onClose} onKeyDown={_temp}>{t3}{children}</dialog>;
    $[2] = children;
    $[3] = label;
    $[4] = onClose;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(event) {
  return event.stopPropagation();
}